import { Injectable } from '@angular/core';
import { TreeModel } from './data/tree';

@Injectable()
export class TreeFilterService {

  constructor() {
  }

  filterTree(tree: TreeModel,
             filterText: string,
             includeAllAttributes:boolean,
             customFilter:(n:TreeModel)=>boolean): TreeModel {
    const matcher = includeAllAttributes ? matchesAny : matchesLabel;
    tree.visible = false;

    filterText = filterText.trim().toLowerCase();

    tree.visible = matcher(tree, filterText);
    if(customFilter){
      tree.visible = tree.visible && customFilter(tree);
    }

    if (tree.hasOwnProperty("children")) {
      if(tree.visible){
        tree.children?.forEach(child=>this.showAll(child));
      } else {
        tree.children?.map(child => {
          this.filterTree(child, filterText,includeAllAttributes,customFilter);

          tree.visible = tree.visible || child.visible;
          tree.expanded = tree.expanded || child.visible || child.expanded;
        });
      }
    }

    return tree;

  }

  showAll(tree:TreeModel){
    tree.visible=true;
    if (tree.hasOwnProperty("children")) {
      tree.children?.forEach(c=>this.showAll(c));
    }
  }
}

function containsFilterText(label: string, filterText: string): boolean{
  return label.trim().toLowerCase().indexOf(filterText.trim().toLowerCase()) !== -1;
}

export function containsFilterTextNested(data:any,filterText:string):boolean{
  if(!data){
    return false;
  }

  if(typeof(data)==='string'){
    return containsFilterText(data,filterText);
  }

  if(Array.isArray(data)){
    return data.some(d=>containsFilterTextNested(d,filterText));
  }

  return Object.keys(data).some(k=>containsFilterTextNested(data[k],filterText));
}

function matchesLabel(treeModel: TreeModel, filterText: string): boolean {
  return containsFilterText(treeModel.label,filterText);
}

function matchesAny(treeModel: TreeModel, filterText: string) : boolean {
  if(matchesLabel(treeModel, filterText)){
    return true;
  }
  
  return containsFilterTextNested(treeModel.data,filterText);
}